var map = {
	"./ban-wechat/manifest.json": [
		24,
		3
	],
	"./gallery/manifest.json": [
		25,
		4
	],
	"./navigation-sound/manifest.json": [
		26,
		5
	],
	"./rss-feed/manifest.json": [
		27,
		6
	],
	"./statistics/manifest.json": [
		28,
		7
	],
	"./telegram-helper/manifest.json": [
		29,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 47;
module.exports = webpackAsyncContext;